/* eslint-disable import/prefer-default-export */
// disabled so that this selector keeps the same format as other selectors
export const content = (state, id) => {
  const externalContent = state.content.get('external_content');
  if (!externalContent) {
    return id ? '' : {};
  }
  if (id) {
    return externalContent.get(id) || '';
  }
  return externalContent.toJS();
};
